import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { Button, Input, FormField } from '@cian/ui-kit';
import * as styles from './OwnerOfferLinkField.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var REGEX_LINK = /http[s]?:\/(?:\/[^\/]+){1,}(?:\/[А-Яа-я\w ]{3,5}(?![\/]))/; // eslint-disable-line

export var OwnerOfferLinkField = function OwnerOfferLinkField(_ref) {
  var label = _ref.label;
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    errorMessage = _React$useState4[0],
    setErrorMessage = _React$useState4[1];
  var handleChange = function handleChange(_, val) {
    if (!REGEX_LINK.test(val)) {
      setErrorMessage('Указана некорректная ссылка');
    } else {
      setErrorMessage('');
    }
    setValue(val);
  };
  var handleClick = function handleClick() {
    if (value) {
      var url = "".concat(value, "#complain");
      window.open(url, '_blank');
    }
  };
  return /*#__PURE__*/_jsx(FormField, {
    label: label,
    withoutMargin: true,
    errorMessage: errorMessage,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles['wrapper'],
      children: [/*#__PURE__*/_jsx(Input, {
        size: "XS",
        value: value,
        onChange: handleChange
      }), /*#__PURE__*/_jsx(Button, {
        disabled: !value || !!errorMessage,
        type: "button",
        size: "XS",
        onClick: handleClick,
        children: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C"
      })]
    })
  });
};